import Student from "types/Student";
import { Card } from "./ui/Card";

interface StudentSummaryProps {
  student: Student;
}

export function StudentSummary({ student }: StudentSummaryProps) {
  return (
    <Card>
      <div className="flex items-center justify-between ml-12 lg:ml-0">
        <div>
          <h2 className="text-lg lg:text-xl font-bold">{student.name}</h2>
          <p className="text-xs lg:text-sm text-gray-600">
            {student.subjects.map((s) => s.subject).join(", ")}
          </p>
        </div>
      </div>
    </Card>
  );
}
